import React from 'react'
import moment from 'moment'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { FOOD_SAFETY_SECTION } from 'src/constants/foodSafety'
import FoodSafetyReportDayPanel from 'src/components/food-safety/FoodSafetyReportDayPanel'
import PermissionBlockScreen from 'src/components/shared/PermissionBlockScreen'
import useIsBlocked from 'src/hooks/useIsBlocked'

/** Unclassified records stay inspection evidence; never infer a check method. */
export default function FoodSafetyEquipmentHistoryScreen() {
  const { venueId } = useParams()
  const history = useHistory()
  const location = useLocation()
  const blocked = useIsBlocked('food-safety')
  const date = new URLSearchParams(location.search).get('date')
  const validDate = moment(date, 'YYYY-MM-DD', true).isValid()
  const reportsHref = `/v/${venueId}/food-safety/reports${
    validDate
      ? `?week=${moment(date).startOf('isoWeek').format('YYYY-MM-DD')}`
      : ''
  }`
  if (blocked) return <PermissionBlockScreen />
  return (
    <div>
      <h1>Unclassified historical equipment</h1>
      <p>
        These original records have no confirmed equipment type. View their
        readings and audit history below.
      </p>
      <Link to={reportsHref}>Back to reports</Link>
      {validDate ? (
        <FoodSafetyReportDayPanel
          venueId={venueId}
          localDate={date}
          focusSection={FOOD_SAFETY_SECTION.LEGACY_EQUIPMENT}
          open
          readOnly
          onClose={() => history.push(reportsHref)}
        />
      ) : (
        <p>Select a date in Reports to view historical equipment records.</p>
      )}
    </div>
  )
}
